import classNames from 'classnames';
import { useMemo } from 'react';

import { SafeInnerHtmlSetter } from 'components/shared/util/SafeInnerHtmlSetter';
import { markdownToHtml } from 'utils/markdown';

import { localizeMessageTimestamps } from '../../../../../../utils/localizeTimestamps';

import styles from './mimSidekickMessage.module.scss';

type MimSidekickMessageProps = {
  role: 'user' | 'assistant' | 'system';
  text: string;
};

export const MimSidekickMessage = ({
  role,
  text,
}: MimSidekickMessageProps): JSX.Element => {
  const isUser = role === 'user';
  const html = useMemo(
    () => markdownToHtml(localizeMessageTimestamps(text)),
    [text],
  );
  return (
    <SafeInnerHtmlSetter
      element="div"
      className={classNames(styles.bubble, {
        [styles.bubbleUser]: isUser,
        [styles.bubbleAssistant]: !isUser,
      })}
      content={html}
      profile="sidekick"
    />
  );
};
